import React, { useContext } from 'react';
import { DetailContext, DetailHandle } from '@eas/common-web';
import { EsFile } from '@models';
import { useCourtFilePermission } from '../../../es-file/es-file-permission';
import { IndexesFields as Indexes } from '../../../es-file/fields/indexes/indexes';

export function IndexesFields() {
  const { source } = useContext<DetailHandle<EsFile>>(DetailContext);

  const { hasPermission } = useCourtFilePermission(source.data);

  return (
    <>
      <Indexes hasPermission={hasPermission} />
    </>
  );
}
